module.exports = __webpack_public_path__ + "resources/img/bg_cover_solution_v2.17ceb26dc22834f4e4d333203da992f0.png";